import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { RestService } from '../rest/rest.service';
import { RestOptions } from '../rest/rest-request';
import {
  MarketOutlook,
  MarketOutlookResponse,
  NewsContent,
  NewsReport,
  SecurityNewsResponse
} from '../../domain/public-api';

@Injectable({ providedIn: 'root' })
export class MarketInfoNewsRestService {

  constructor(private restService: RestService) {
  }

  /**
   * Retrieve market outlook (reports & news, indicators)
   * marketIndicators are not returned when markets are open
   */
  getMarketOutlook(): Observable<MarketOutlook> {
    return this.restService.getResource('markets.outlook')
      .get<MarketOutlookResponse>()
      .pipe(
        map((response: MarketOutlookResponse): MarketOutlook => response?.marketOutlook)
      );
  }

  getNewsItem(storyId: string): Observable<NewsContent> {
    return this.restService.getResource('markets.news').get({
      pathVariables: { storyId }
    } as RestOptions);
  }

  getSecuritiesNews(securities: Array<string>, limit: number,
                    dateRange?: { startDate: Date; toDate: Date }): Observable<Array<NewsReport>> {
    const parameters: RestOptions = {
      params: { securities, limit }
    };

    if (dateRange !== undefined) {
      parameters.params.fromDate = dateRange.startDate;
      parameters.params.toDate = dateRange.toDate;
    }

    return this.restService.getResource('security.news')
      .get<SecurityNewsResponse>(parameters)
      .pipe(
        map((response: SecurityNewsResponse): Array<NewsReport> => response?.news ?? undefined)
      );
  }
}

